import Linkify from 'linkify-react';
import React, { ComponentProps } from 'react';
import { Link } from 'components/Link';
import { Paragraph } from 'components/Typography/Paragraph';

type Props = ComponentProps<typeof Paragraph>;

/** Will render a paragraph and replace and links found inside with an external link component */
export const LinkedParagraph: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <Paragraph {...rest}>
      <Linkify
        options={{
          render: ({ content, attributes }) => {
            return (
              <Link to={attributes.href ?? content} target="_blank" includeDefaultClasses disableExternalLinkIcon>
                {content}
              </Link>
            );
          },
        }}
      >
        {children}
      </Linkify>
    </Paragraph>
  );
};
